/**
 * Vertical progress stepper for a short, ordered setup flow. Display only —
 * no interaction of its own beyond an optional link inside a step's subtitle.
 * Spec: assets/handoffs/design_handoff_new_calendar_page/README.md §4
 *
 * A "done" step is expected to carry its collapsed answer in `title`
 * (e.g. "Detailed list") rather than the original instruction — the caller
 * decides the copy per step, this component only draws the status.
 *
 * @param {Array<{key:string, status:'done'|'current'|'upcoming'|'blocked'|'failed', title:string, subtitle?:ReactNode}>} steps
 */
import React from "react";
import classNames from "classnames";
import Icon from "../icons/Icon";
import styles from "./ProgressSteps.module.scss";

const ProgressSteps = ({ steps, className, ...rest }) => {
  return (
    <div className={classNames(styles.root, className)} {...rest}>
      {steps.map((step, index) => (
        <div
          key={step.key}
          className={classNames(styles.step, styles[`step--${step.status}`], {
            [styles["step--last"]]: index === steps.length - 1,
          })}
        >
          <span className={styles.dot} aria-hidden="true">
            {step.status === "done" ? (
              <Icon name="Check" size={12} className={styles.dotIcon} />
            ) : (
              (step.status === "current" || step.status === "blocked") && (
                <span className={styles.dotInner} />
              )
            )}
          </span>
          <div className={styles.body}>
            <span className={styles.title}>{step.title}</span>
            {step.subtitle && <div className={styles.subtitle}>{step.subtitle}</div>}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProgressSteps;
